import axios from "axios";
import Vue from "vue";

// Helper to access loading plugin
const getLoadingPlugin = () => {
  // Try to access from Vue prototype (plugin is installed on Vue.prototype.$loading)
  if (Vue && Vue.prototype && Vue.prototype.$loading) {
    return Vue.prototype.$loading;
  }
  return null;
};

// Helper to access toast plugin
const getToastPlugin = () => {
  // Try to access from Vue prototype (plugin is installed on Vue.prototype.$toast)
  if (Vue && Vue.prototype && Vue.prototype.$toast) {
    return Vue.prototype.$toast;
  }
  return null;
};

export const printData = async (
  data,
  api,
  method,
  params = null,
  vm = null
) => {
  // Get loading and toast plugins from Vue prototype
  const loading = getLoadingPlugin();
  const toast = getToastPlugin();

  try {
    // Démarre le loading s'il est disponible
    if (loading && loading.start) {
      loading.start();
    }

    // Construire l'URL API (encodeURIComponent: références facture avec « / », etc.)
    let apiUrl = api;
    if (method.toUpperCase() === "GET" && params != null && params !== "") {
      apiUrl += `/${encodeURIComponent(String(params))}`;
    }

    const config = {
      responseType: "json",
      timeout: 30000,
    };

    if (method.toUpperCase() === "GET") {
      config.params = {};
    } else {
      config.data = data;
    }

    const response = await axios[method.toLowerCase()](apiUrl, config);

    // Convertir la réponse base64 en PDF
    const binaryData = atob(response.data.output);
    const bytes = new Uint8Array(binaryData.length);
    for (let i = 0; i < binaryData.length; i++) {
      bytes[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });
    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", response.data.filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up URL after download
    setTimeout(() => {
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);

    // Message de succès
    if (toast && toast.success) {
      toast.success("Téléchargement terminé avec succès !");
    }
  } catch (error) {
    console.error("Error printing PDF:", error);
    if (toast && toast.error) {
      toast.error("Une erreur est survenue lors de l'impression.");
    }
  } finally {
    // Arrête le loading quoi qu'il arrive
    if (loading && loading.stop) {
      loading.stop();
    }
  }
};

/*import axios from "axios";

export const printData = async (
  data,
  api,
  method,
  params = null,
  vm = null
) => {
  try {
    // Démarre le loading s'il est disponible
    if (vm && vm.$loading) vm.$loading.start();

    // Construire l'URL API
    let apiUrl = api;
    if (method.toUpperCase() === "GET" && params) {
      apiUrl += `/${params}`;
    }

    const config = {
      responseType: "json",
    };

    if (method.toUpperCase() === "GET") {
      config.params = {};
    } else {
      config.data = data;
    }

    const response = await axios[method.toLowerCase()](apiUrl, config);

    // 👉 Envoyer le PDF au serveur local d'impression avec fetch (au lieu d'Axios)
    await fetch("http://localhost:5000/print", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        base64Data: response.data.output,
        filename: response.data.filename,
      }),
    });

    // Message de succès
    if (vm && vm.$toast) vm.$toast.success("Impression envoyée avec succès !");
  } catch (error) {
    console.error(error);
    if (vm && vm.$toast)
      vm.$toast.error("Une erreur est survenue lors de l'impression.");
  } finally {
    // Arrête le loading quoi qu’il arrive
    if (vm && vm.$loading) vm.$loading.stop();
  }
};*/
